const state = {
  isAdminUser: true,
  userRoles: [],
  userName: '',
};

export default state;
